export class TabItemEntity {
  label;
  value;
  data;

  constructor(label = "", value = null, data = null) {
    this.label = label;
    this.value = value;
    this.data = data;
  }
}
